import { OptionsType } from "react-select";
import {
  CarFuelOptions,
  MotorcycleFuelOptions,
} from "../transport/transportSlice";

export interface FuelType {
  label: string;
  value: CarFuelOptions | MotorcycleFuelOptions;
}

interface CarFuelTypes {
  gasoline: FuelType;
  diesel: FuelType;
  hybrid: FuelType;
  electric: FuelType;
}

interface MotorcycleFuelTypes {
  gasoline: FuelType;
  electric: FuelType;
}

export const CAR_FUEL_TYPES: CarFuelTypes = {
  gasoline: {
    label: "Gasolina",
    value: "gasoline",
  },
  diesel: {
    label: "Gasóleo",
    value: "diesel",
  },
  hybrid: {
    label: "Híbrido",
    value: "hybrid",
  },
  electric: {
    label: "Eléctrico",
    value: "electric",
  },
};

export const MOTORCYCLE_FUEL_TYPES: MotorcycleFuelTypes = {
  gasoline: {
    label: "Gasolina",
    value: "gasoline",
  },
  electric: {
    label: "Eléctrico",
    value: "electric",
  },
};

interface CarDistanceOption {
  label: string;
  value: number;
}

export const DISTANCE_OPTIONS: OptionsType<CarDistanceOption> = [
  {
    label: "0 km",
    value: 0,
  },
  {
    label: "30 - 60 km",
    value: 45,
  },
  {
    label: "70 - 120 km",
    value: 95,
  },
  {
    label: "130 - 170 km",
    value: 150,
  },
  {
    label: "180 - 220 km",
    value: 200,
  },
  {
    label: "230 - 270 km",
    value: 250,
  },
  {
    label: "280 - 320 km",
    value: 300,
  },
  {
    label: "+ 330 km",
    value: 330,
  },
];

export interface PublicTransportUseOption {
  label: string;
  value: number;
}

export const PUBLIC_TRANSPORT_USE_OPTIONS: PublicTransportUseOption[] = [
  {
    label: "0",
    value: 0,
  },
  {
    label: "2 veces",
    value: 2,
  },
  {
    label: "3 veces",
    value: 3,
  },
  {
    label: "4 veces",
    value: 4,
  },
  {
    label: "5 veces",
    value: 5,
  },
  {
    label: "6 veces",
    value: 6,
  },
  {
    label: "7 veces",
    value: 7,
  },
  {
    label: "+ 8 veces",
    value: 8,
  },
];

export interface FlightOption {
  label: string;
  value: number;
}

export const FLIGHT_OPTIONS: FlightOption[] = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "+5",
    value: 5,
  },
];
